import moment, { Moment } from 'moment';

/**
 * Door de gebruiker tussengevoegde momenten (rijen) op de ephemeris-pagina. Bewust enkel voor
 * de huidige sessie (wens Steven 2026-10-13): sessionStorage, dus weg wanneer het tabblad sluit,
 * maar wel nog daar na een herlaadbeurt.
 */
export const EPHEMERIS_INSERTED_STORAGE_KEY = 'egitura.hd.ephemeris.inserted';

/** ISO-UTC-sleutel van een moment (op de seconde), zelfde vorm als de API-parameter. */
export function ephemerisMomentKey(atUtc: Moment): string {
  return moment.utc(atUtc).format('YYYY-MM-DDTHH:mm:ss[Z]');
}

export function loadInsertedMoments(): readonly string[] {
  try {
    const raw = sessionStorage.getItem(EPHEMERIS_INSERTED_STORAGE_KEY);
    const parsed: unknown = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed)
      ? parsed.filter((value): value is string => typeof value === 'string' && moment.utc(value, moment.ISO_8601, true).isValid())
      : [];
  } catch {
    return [];
  }
}

export function saveInsertedMoments(keys: readonly string[]): void {
  try {
    sessionStorage.setItem(EPHEMERIS_INSERTED_STORAGE_KEY, JSON.stringify(keys));
  } catch {
    // Opslag geblokkeerd: de ingevoegde rijen gelden dan enkel tot de pagina sluit.
  }
}
